module.exports = __webpack_public_path__ + "static/media/autograder-loading.c12acc72.svg";